import React from 'react';
import { INavbarFrameProps, INavbarFrameConnectedProps, INavbarOpenProps } from '..';
import { NavbarDesktop } from '../desktop';
import { NavbarMobile } from '../mobile';

export const NavbarFrame: React.FC<INavbarFrameProps & INavbarFrameConnectedProps & INavbarOpenProps> = props => {
  return props.small ? <NavbarMobile {...props} /> : <NavbarDesktop {...props} />;
};
